import axios from '@/libs/axios'

export function apiService() {

  /**
   * get linked items to specific user
   * devices, geofences, contracts, containers, users, ....
   * @param queryParams
   * @returns {Promise<unknown>}
   */
  const getLinked = (queryParams) => {
    return new Promise((resolve, reject) => {
      axios.get('userGetLinked', { params: queryParams })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }


  const filterOptions = (queryParams) => {
    return new Promise((resolve, reject) => {
      axios.get('links', { params: queryParams })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  return {
    getLinked,
    filterOptions
  }

}